import { useState } from "react";

import { Form, FormInstance } from "antd";

import { useAppSelector } from "store";
import { getUserSelector } from "store/user/user.selector";
import infoIcon from "data/icons/info-circle.svg";
import infoIconBlue from "data/icons/info-circle-blue.svg";
import warningIcon from "data/icons/warning-circle.svg";
import warningIconOrange from "data/icons/warning-circle-orange.svg";
import exclamationIcon from "data/icons/exclamation-circle.svg";
import exclamationIconRed from "data/icons/exclamation-circle-red.svg";

const severities = [
  {
    value: 0,
    label: "Low",
    icon: infoIcon,
    iconActive: infoIconBlue,
    className: "custom-radio-item-info",
  },
  {
    value: 1,
    label: "Normal",
    icon: infoIcon,
    iconActive: infoIconBlue,
    className: "custom-radio-item-info",
  },
  {
    value: 2,
    label: "Degraded",
    icon: warningIcon,
    iconActive: warningIconOrange,
    className: "custom-radio-item-major",
  },
  {
    value: 3,
    label: "Critical",
    icon: exclamationIcon,
    iconActive: exclamationIconRed,
    className: "custom-radio-item-critical",
  },
]

interface IProps {
  form: FormInstance;
}

const CaseSeveritiesField = ({ form }: IProps) => {
  const { isMobile } = useAppSelector(getUserSelector);

  const [ stateBool, forceUpdate ] = useState(false);

  return (
    <Form.Item
      name="severity"
      initialValue="info"
    >
      <div className={ `custom-radio-group ${ isMobile ? "mobile" : "" }` }>
        { severities.map((severity) => (
          <div
            className={ `custom-radio-item ${ (
              form.getFieldValue("severity") === undefined
                ? severity.value === 0
                : form.getFieldValue("severity") === severity.value)
              ? severity.className : ""
            }` }
            key={ severity.value }
            onClick={ () => {
              form.setFieldsValue({ severity: severity.value })
              forceUpdate(!stateBool);
            } }
          >
            <img
              alt=""
              src={ form.getFieldValue("severity") === severity.value
                ? severity.iconActive
                : severity.icon }
            />
            <p className="custom-radio-title">{ severity.label }</p>
          </div>
        )) }
      </div>
    </Form.Item>
  );
};

export default CaseSeveritiesField;
